import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import HeaderTop from "../../components/header/HeaderTop";
import actions, { useActions } from "../../../redux/actions";

const HeaderOne = ({
  layout,
  top,
  borderStyle,
  headerPaddingClass,
  headerBgClass,
}) => {
  const { t } = useTranslation();
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);

  const cookies = new Cookies();
  const token = cookies.get("token", { path: "/" });
  const role = cookies.get("role", { path: "/" });

  const MeActions = useActions(actions.MeActions);
  const [balance, setBalance] = useState(0);

  const storeConfig = useSelector((state) => state.storeConfig);

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  useEffect(() => {
    if (token) {
      MeActions.getWallet(token)
        .then((response) => {
          const {
            message: { record: { availableAmount = 0 } = {} },
          } = response || {};
          setBalance(availableAmount);
        })
        .catch(() => {
          setBalance(0);
        });
    }
  }, [token]);

  return (
    <header className={`header-area clearfix ${headerBgClass || ""}`}>
      <div
        className={`${headerPaddingClass || ""} ${
          top === "visible" ? "d-none d-lg-block" : "d-none"
        } header-top-area ${
          borderStyle === "fluid-border" ? "border-none" : ""
        }`}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          {/* header top */}
          <HeaderTop borderStyle={borderStyle} />
        </div>
      </div>

      <div
        className={` ${
          headerPaddingClass || ""
        } sticky-bar header-res-padding clearfix ${
          scroll > headerTop ? "stick" : ""
        }`}
      >
        <div
          className={layout === "container-fluid" ? layout : "container"}
          id="header-wrapper"
        >
          <div className="row d-flex align-items-center mobileFlex">
            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 logo-row">
              {/* header logo */}
              {storeConfig && storeConfig.logo && (
                <Logo imageUrl={storeConfig.logo.fileUrl} logoClass="logo" />
              )}
            </div>
            <div className="col-xl-8 col-lg-7 d-none d-lg-block">
              {/* Nav menu */}
              <NavMenu scrolled={scroll > headerTop} />
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 icon-row">
              {/* Icon group */}
              <IconGroup />
            </div>
          </div>
          {/* {token && role === "customer" && ( */}
          {/*  <p className="coins">{t("navMenu.balance", { coins: balance })}</p> */}
          {/* )} */}
        </div>
        {/* mobile menu */}
        <MobileMenu />
      </div>
    </header>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string,
};

export default HeaderOne;
